<template>
    <b-button class="h-100" :variant="variant"
              :disabled="loading || disable"
              :class="loading ? loadingClass:''"
              @click="onClick">
        <b-spinner small v-if="loading"></b-spinner>
        <i class="fa-solid fa-trash-can" v-else></i>
    </b-button>
</template>
<script>

export default {
    name: "DeleteButton",
    props: {
        variant: {
            type: String,
            default: 'danger'
        },
        loading: {
            type: Boolean,
            default: false
        },
        disable: {
            type: Boolean,
            default: false
        },
        loadingClass: {
            type: String,
            default: ''
        },
        noConfirm: {
            type: Boolean,
            default: false
        },
        confirmText: {
            type: String,
            default: '确认删除吗？'
        },
        additionText: String
    },
    methods: {
        confirmClick() {
            this.$emit('confirming');
            let text = this.confirmText;
            if (this.additionText) {
                text = `确认删除 ${this.additionText} 吗？`;
            }
            this.$bvModal.msgBoxConfirm(text, {
                title: '请确认',
                headerBgVariant: 'light',
                headerClass: 'text-dark',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: '是',
                cancelTitle: '否',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(confirm => {
                if (confirm) {
                    this.$emit('btnClick');
                } else {
                    this.$emit('noConfirm')
                }
            });
        },
        onClick() {
            if (this.noConfirm) {
                this.$emit('btnClick');
            } else {
                this.confirmClick();
            }
        },
    }
}
</script>
<style>
.text-dark .modal-title {
    color: black !important;
}
</style>
